import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ChildrenOutletContexts, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ServerClientService } from '../../global/services/data/campaign-service/server-client.service';
import { MainModel } from '../../global/model/MainModel';
import NavModel from '../../global/model/NavModel';
import { DashboardComponent } from '../../global/page/dashboard/dashboard.component';
import { BreadcrumbComponent } from "../../global/component/breadcrumb/breadcrumb.component";
import { AppBarComponent } from "../../global/component/app-bar/app-bar.component";
import { CampaignSwitcherComponent } from "../../global/component/campaign-switcher/campaign-switcher.component";
import { MainNavComponent } from "../../global/component/main-nav/main-nav.component";
import { ToastModule } from 'primeng/toast';
import { NgClass, NgIf } from '@angular/common';
import {Location} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { DisplayService, SCREEN_PROFILE } from '../../global/services/ui/DisplayService';
import { DialogModule } from 'primeng/dialog';
import { GenericButtonComponent } from '../../global/component/generic/generic-button/generic-button.component';
import { SearchPageComponent } from '../../global/page/search/search.page.component'; 
import { DonationsSearchComponent } from '../../vortex/page/donations-search/donations-search.component';
import { SearchModel } from '../../global/model/SearchModel';
import { DonorSearchComponent } from "../../vortex/page/donor-search/donor-search.component";
import { MessageService } from 'primeng/api';
import { ExpensesComponent } from '../../vortex/page/expenses/expenses.component';
interface SearchArea {
  name: string;
  code: string;
}

@Component({
  selector: 'app-default',
  standalone: true,
  imports: [RouterOutlet, NgIf, BreadcrumbComponent, AppBarComponent, CampaignSwitcherComponent, MainNavComponent, ToastModule, NgClass,
    FormsModule, DropdownModule, ButtonModule, InputGroupModule, InputTextModule, DialogModule, GenericButtonComponent, SearchPageComponent, DonationsSearchComponent, DonorSearchComponent, ExpensesComponent],
  templateUrl: './default.component.html',
  providers: [MessageService],
  styleUrl: './default.component.scss'
})

export class DefaultComponent implements OnInit{
  isOpen = true;
  isShowBreadcrumb:boolean = false;
  displayComponent:any = DashboardComponent;
  currentApp: string = "admin";
  campaignList: any = [];
  SCREEN_PROFILE = SCREEN_PROFILE;

  //  areas: SearchArea[] | undefined;
   areas: SearchArea[] = [
    { name: 'Donors', code: 'NY' },
    { name: 'Donations', code: 'RM' },
    { name: 'Expenses', code: 'LDN' },
    { name: 'Batches', code: 'IST' },
    { name: 'Bundlers', code: 'PRS' },
    { name: 'Events', code: 'EV' }
  ];
  selectedSearchArea: SearchArea | undefined;
  searchKeyword: string = '';
  showSearchDialog: boolean = false;
  showDonationsSearchDialog: boolean = false;
  showExpensesSearchDialog: boolean = false;
  showDonorSearchDialog: boolean = false;
  pagingModel: any = {}; 
  columnData: SearchModel = {
    displayColumns: [],
    states: [],
    fundCodes: [],
    commonFilters: [],
    textFilters: [],
    fundraisers: [],
    sources: [],
    events: [],
    amountFilters: [],
    statusOptions: [],
    approvalOptions: [],
    batchTypes: [],
    checkbooks: [],
    dateFilters: [],
  };

  toggle() {
    console.debug(this.model.navigation.currentState)
    //this.isOpen = !this.isOpen;
    this.model.navigation.toggleMainNavState();
  }

  constructor(
    private serverClient: ServerClientService, 
    private contexts: ChildrenOutletContexts|null, 
    protected model:MainModel,
    private router:Router,
    private activeRoute:ActivatedRoute,
    private _location: Location,
    protected display:DisplayService,
    private messageService: MessageService
    ) {
      router.events.subscribe((value:any) => {
        // TODO: Figure out if anything here would be advantageous or not...JMW
        // if(value instanceof NavigationEnd){
        //   if(value instanceof NavigationEnd){
        //       console.debug(this.activeRoute);
        //       }
        //   }
        });
    };

    goBack(){
      this._location.back();
    }

    toggleMenu(){
      this.model.navigation.toggleMainNavState();
    }

    ngOnInit() {
      this.selectedSearchArea= this.areas[0];
    }

    clearSearchCriteria(){
      this.showSearchDialog = false;
      this.showDonationsSearchDialog = false;
      this.showExpensesSearchDialog = false;
      this.showDonorSearchDialog= false;
      this.selectedSearchArea = undefined;
      this.searchKeyword = '';
      this.selectedSearchArea= this.areas[0];
    }
    
    globalSearch() {
      if(!this.selectedSearchArea) { 
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'please select a search area.',
          life: 7500
        });
        console.error("please select a search area.");
        return;
      };
      if(!this.searchKeyword.trim()) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'please enter a keyword.',
          life: 7500
        });
        console.error("please enter a keyword");
        return;
      };

      if(this.selectedSearchArea.name === "Donors")  
        this.showDonorSearchDialog = true;
      else if(this.selectedSearchArea.name === "Donations")  
        this.showDonationsSearchDialog = true;
      else if(this.selectedSearchArea.name === "Expenses")  
        this.showExpensesSearchDialog = true;
      else
        this.showSearchDialog = true;
    }

    handleCancel(){
      this.showSearchDialog = false;
      this.showDonationsSearchDialog = false;
      this.showDonorSearchDialog = false;
      this.showExpensesSearchDialog = false;
    }
}

